import { render } from "./about.vue?vue&type=template&id=573c6776&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=573c6776&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-573c6776"

export default script